import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/financial")({
  beforeLoad: () => {
    throw redirect({ to: "/financial-intelligence" });
  },
});
